// Need to use the React-specific entry point to import createApi
import apiSlice from "../../apiSlice";


const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        listUsers: builder.query({
            query: () => ({
                url: '/users/'
            })
        }),
        retrieveUser: builder.query({
            query: (payload) => ({
                url: `/users/${payload.id}`
            })
        }),
        updateUser: builder.mutation({
            query: (payload) => ({
                method: "PATCH",
                url: `/users/${payload.id}/`,
                body: payload.data
            })
        }),
    }),
});
export const { useRetrieveUserQuery, useListUsersQuery, useUpdateUserMutation, } = usersApiSlice